__turbopack_context__.v({
  "faq-block": "FaqBlock-module-scss-module__DlTMKq__faq-block",
  "faq-block__body": "FaqBlock-module-scss-module__DlTMKq__faq-block__body",
  "faq-block__content": "FaqBlock-module-scss-module__DlTMKq__faq-block__content",
  "faq-block__filter": "FaqBlock-module-scss-module__DlTMKq__faq-block__filter",
  "faq-block__flourish": "FaqBlock-module-scss-module__DlTMKq__faq-block__flourish",
  "faq-block__header": "FaqBlock-module-scss-module__DlTMKq__faq-block__header",
  "faq-block__heading": "FaqBlock-module-scss-module__DlTMKq__faq-block__heading",
  "faq-block__inner": "FaqBlock-module-scss-module__DlTMKq__faq-block__inner",
  "faq-block__list": "FaqBlock-module-scss-module__DlTMKq__faq-block__list",
  "faq-block__radio-input": "FaqBlock-module-scss-module__DlTMKq__faq-block__radio-input",
  "faq-block__radio-label": "FaqBlock-module-scss-module__DlTMKq__faq-block__radio-label",
  "faq-block__wrapper": "FaqBlock-module-scss-module__DlTMKq__faq-block__wrapper",
});
